import React, { useEffect, useMemo, useState } from "react";
import FormPCF from "./FormPCF";
import PCFPreview from "./PCFPreview";
import { CardMessage } from "../../Components/PCFUI";
import { StdHeader } from "../../../Profiles/components";
import { WarningStudyPeriode } from "../../../Dashboard/Widget";
import { REQUEST_TARGET_MODULES } from "../../../../../Library/APIsTarget";

export default function FirstPCFCom({
  student_status,
  student_bio,
  ref_acad,
  rereg_data,
}) {
  const student_detail = useMemo(() => {
    const combined_data = {
      ...student_bio,
      bio_id: student_bio?.id,
      ...student_status,
    };
    return combined_data;
  }, [student_bio, student_status]);

  const studentid = student_status.studentid;
  const current_program = student_status?.program?.id || "";
  const current_semester = student_status?.semester || 0;
  const [prevPCF, setPrevPCF] = useState({
    pcf: [],
    data: [],
    param: [],
    totalsks: 0,
    open: false,
  });

  const [is_transfer, setIstransfer] = useState({ loading: false, data: [], message: "" });
  const CheckStudentProposal = async () => {
    setIstransfer({ loading: true, data: [], message: "" });
    const isTransferStudent = await StudentProposalCheck(student_status);
    setIstransfer({ loading: false, data: isTransferStudent, message: "" });
  };

  //   useEffect(()=>{
  //     CheckStudentProposal();
  //   },[])

  return (
    <div id="first-pcf">
      <div className={prevPCF.open ? "d-none" : "d-block"}>
        <StdHeader student={student_detail} />
        {(current_program === 1 && current_semester > 14) ||
          (current_program === 2 && current_semester > 8) ? (
          <WarningStudyPeriode student={student_status} />
        ) : rereg_data && rereg_data.message ? (
          <CardMessage message={rereg_data.message} icon={"box"} />
        ) : (
          // is_transfer.loading ? <LoadingBtn /> :
          // is_transfer.data && Object.keys(is_transfer.data).length > 0 ? (
          //     is_transfer.data?.transid ?
          //     <CardMessage message={`transfer proposal sedang di proses ${is_transfer.data?.status}`} icon={"box"} /> :
          //     <CardMessage message={`belom dibuatin proposal`} icon={"box"} />
          // ) : 
          <FormPCF
            data={rereg_data.data}
            student={student_status}
            student_bio={student_bio}
            ref_acad={ref_acad}
            setPrevPCF={setPrevPCF}
          />
        )}
      </div>
      <div className={prevPCF.open ? "d-block" : "d-none"}>
        <PCFPreview
          data_prev={prevPCF}
          setPrevPCF={setPrevPCF}
          student_bio={student_bio}
          studentid={studentid}
        />
      </div>
    </div>
  );
}

const StudentProposalCheck = async (student) => {
  const key_enrollment_corporate = "mkt.enrollment.type.corporate";
  const key_transfer_rpl = "mkt.enrollment.transfer.type.learningprogram";
  const key_transfer = "mkt.enrollment.transfer.type.transfer";

  // const [proposal, setProposal] = useState()
  if (
    student?.enrollment_type_id === key_enrollment_corporate ||
    (student.transfer_type &&
      (student.transfer_type_id === key_transfer_rpl ||
        student.transfer_type_id === key_transfer))
  ) {
    const param = {
      parameters: { candidate_id: student.studentid.toString() },
      target_data: "GET_TRANSFER_PROPOSAL",
    };
    const results = await REQUEST_TARGET_MODULES(param);
    if (results.data && Object.values(results.data).length > 0) {
      const find_data = results.data.find(
        (item) => item.candidate_id === student.studentid
      );
      const find_appv = results.data.find((item) => item.status === "APPROVED");
      if (find_appv) return {};
      else return find_data;
    } else {
      return student;
    }
  } else {
    return {};
  }
};
